import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';

const FoundationIntro: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>基金会简介</h1>
                <div className='foundation-content'>
                    <p>浙江绿城爱心教育基金会（以下简称绿城教育基金会）是于2021年12月29日通过浙江省民政厅审批正式成立的慈善组织。</p>
                    <p>绿城教育基金会使命：怀仁爱之心，躬行教育公益，服务社会发展。以专业化、透明化的运营，锻造值得信赖的公益品牌；汇聚各方力量，为受助者、捐赠者和社会创造价值</p>
                    <p>未来将在教育行业开展更多具有影响力的公益项目，为中国的教育事业发展添砖加瓦，努力成为教育公益行业的典范与标杆。</p>
                </div>
            </div>
        } />
    );
};

export default FoundationIntro;